import React from 'react';
import { META_STATUS_TYPE } from './SocialMediaConstant';

const getStatusClass = (status) => {
    switch (status) {
        case 'Published':
            return 'bg-success text-white';
        case 'Un-Published':
            return 'bg-danger text-white';
        case 'Partially Published':
            return 'bg-warning text-dark';
        default:
            return 'bg-secondary text-white';
    }
};

const PublishOrUnPublishStatusCard = ({ dataItem }) => {
    const getAdStatus = () => {
        if (!dataItem || Object.keys(dataItem).length === 0) return 'Un-Published';
        if (!dataItem.ad_data || dataItem.ad_data.length === 0) return 'Un-Published';

        const hasActiveAds = dataItem.ad_data.some(ad => ad.status === META_STATUS_TYPE.ACTIVE);
        const hasInactiveAds = dataItem.ad_data.some(ad => ad.status !== META_STATUS_TYPE.ACTIVE);

        if (hasActiveAds && !hasInactiveAds) return 'Published';
        if (!hasActiveAds) return 'Un-Published';
        return 'Partially Published';
    };

    const status = getAdStatus();
    const statusClass = getStatusClass(status);

    return (<td>
        <div className={`badge ${statusClass} px-3 py-2 fs-6`}>
            {status}
        </div>
    </td>
    );
};

export default PublishOrUnPublishStatusCard;
